import { render, staticRenderFns } from "./ActionsReclamations.vue?vue&type=template&id=57356ea2&"
import script from "./ActionsReclamations.vue?vue&type=script&lang=js&"
export * from "./ActionsReclamations.vue?vue&type=script&lang=js&"
import style0 from "./ActionsReclamations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports